"use client"

import * as React from "react"
import * as TooltipPrimitive from "@radix-ui/react-tooltip"

import { cn } from "../../lib/utils.js"

// Provider "dummy" temporário para evitar erro de hooks
const TooltipProvider = ({ children, delayDuration, skipDelayDuration, disableHoverableContent, ...props }) => {
  // Filtrar props específicas do TooltipProvider que não são válidas para div
  return <div {...props}>{children}</div>;
};

// const TooltipProvider = TooltipPrimitive.Provider

// Componentes "dummy" temporários para evitar erro de hooks
const Tooltip = ({ children, open, defaultOpen, onOpenChange, ...props }) => {
  // Filtrar props específicas do Tooltip que não são válidas para div
  return <div {...props}>{children}</div>;
};

const TooltipTrigger = ({ children, asChild, ...props }) => {
  // Filtrar a prop asChild para não passá-la para o elemento DOM
  return <div {...props}>{children}</div>;
};

// const Tooltip = TooltipPrimitive.Root
// const TooltipTrigger = TooltipPrimitive.Trigger

// TooltipContent "dummy" temporário para evitar erro de hooks
const TooltipContent = React.forwardRef(({ 
  className, 
  sideOffset = 4, 
  children, 
  side,
  align,
  alignOffset,
  avoidCollisions,
  collisionBoundary,
  collisionPadding,
  sticky,
  hideWhenDetached,
  updatePositionStrategy,
  ...props 
}, ref) => {
  // Filtrar props específicas do TooltipContent que não são válidas para div
  return (
    <div
      ref={ref}
      className={cn(
        "z-50 overflow-hidden rounded-md bg-primary px-3 py-1.5 text-xs text-primary-foreground",
        className
      )}
      style={{ display: 'none' }} // Oculto temporariamente
      {...props}
    >
      {children}
    </div>
  );
});
TooltipContent.displayName = "TooltipContent";

/*
const TooltipContent = React.forwardRef(({ className, sideOffset = 4, ...props }, ref) => (
  <TooltipPrimitive.Portal>
    <TooltipPrimitive.Content
      ref={ref}
      sideOffset={sideOffset}
      className={cn(
        "z-50 overflow-hidden rounded-md bg-primary px-3 py-1.5 text-xs text-primary-foreground animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
        className
      )}
      {...props} />
  </TooltipPrimitive.Portal>
))
TooltipContent.displayName = TooltipPrimitive.Content.displayName
*/

export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider }
